
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Punetobangloreinnovacab() {



    const cardData =
    {
        keyword: 'Pune to Bangalore Innova Cab ',
        heading: 'S9 Travels: Pune to Bangalore Innova Cab ',
        headingDescription: 'S9 Travels offers premium Innova cab services for travelers going from Pune to Bangalore. Whether you are traveling for business, a family vacation, or a personal trip, our fleet of well-maintained Innovas provides a safe, reliable, and luxurious travel experience. The distance between Pune and Bangalore is approximately 840 km, and the journey typically takes around 12 to 13 hours by road. With S9 Travels, enjoy a smooth, comfortable, and hassle-free ride to one of India"s most vibrant cities.',

        top: 'Top Places to Visit in Bangalore with S9 Travels',

"topPlaces": [
    {
      "title": "Lalbagh Botanical Garden",
      "description": "Lalbagh is a historic botanical garden and one of the most popular attractions in Bangalore. With over 1,000 species of plants, a large glasshouse, and a variety of gardens, Lalbagh offers a peaceful retreat in the city. It's also home to the annual flower show, which attracts thousands of visitors."
    },
    {
      "title": "Bangalore Palace",
      "description": "Bangalore Palace is a majestic royal residence, built in the Tudor style, and it offers visitors a glimpse into the opulent lifestyle of the Maharajas. The palace features beautiful woodwork, intricate carvings, and stunning paintings. A visit here allows you to experience the grandeur of royal history."
    },
    {
      "title": "Cubbon Park",
      "description": "Cubbon Park is a sprawling green space located in the heart of Bangalore. Ideal for morning walks, jogs, or simply relaxing in nature, this park is perfect for nature lovers. It is surrounded by various government buildings and institutions, making it a peaceful oasis in the bustling city."
    },
    {
      "title": "Vidhana Soudha",
      "description": "Vidhana Soudha is an architectural marvel and the seat of the Karnataka Legislature. Its grand design and imposing structure make it one of the most prominent landmarks in Bangalore. While the building itself is not open to the public, visitors can admire its beauty from the outside and learn about its historical importance."
    },
    {
      "title": "Bannerghatta National Park",
      "description": "For nature enthusiasts and wildlife lovers, Bannerghatta National Park is a must-visit. The park offers a safari experience where you can spot animals like tigers, lions, and bears. It also features a zoo, butterfly park, and a rescue center for injured animals."
    },
    {
      "title": "Nandi Hills",
      "description": "Located around 60 km from Bangalore, Nandi Hills is a popular weekend getaway known for its scenic beauty and cool climate. The hilltop offers panoramic views of the surrounding landscape and is an excellent spot for trekking, nature walks, and photography. The historic Nandi Temple at the top is another attraction."
    },
    {
      "title": "ISKCON Temple Bangalore",
      "description": "The ISKCON Temple in Bangalore is one of the largest ISKCON temples in India. Located on Hare Krishna Hill, the temple offers a serene and spiritual experience. Visitors can enjoy the peaceful atmosphere, attend devotional prayers, and explore the temple’s vibrant surroundings."
    },
    {
      "title": "Chitrakala Parishath",
      "description": "For art lovers, Chitrakala Parishath is an excellent place to visit. It is an art complex dedicated to promoting traditional and contemporary art forms. The complex features art galleries, exhibitions, and workshops and provides a platform for local and national artists."
    },
    {
      "title": "Ulsoor Lake",
      "description": "Ulsoor Lake, located in the heart of Bangalore, is one of the largest lakes in the city. It offers boat rides, serene views, and a peaceful environment, making it a perfect spot for relaxation. The area surrounding the lake is great for leisurely walks or a picnic."
    },
    {
      "title": "Commercial Street",
      "description": "Commercial Street is one of the busiest and most vibrant shopping streets in Bangalore. It is filled with a variety of shops selling clothes, accessories, footwear, and jewelry. Whether you’re shopping for souvenirs or local items, it’s a great place to experience Bangalore's lively market scene."
    }
],

"services": [
    {
      "name": "Pune to Bangalore Innova Taxi Service",
      "description": "Make your journey from Pune to Bangalore hassle-free and comfortable with our Innova taxi service. Whether it's a one-way trip, round trip, or group travel, our Innova cabs are the perfect choice for a smooth and luxurious ride."
    },
    {
      "name": "Book Pune to Bangalore Innova Cab",
      "description": "Booking an Innova cab for your trip from Pune to Bangalore is easy. Enjoy the comfort and convenience of a spacious vehicle with excellent seating arrangements, ensuring you reach Bangalore in style and comfort."
    },
    {
      "name": "Pune to Bangalore Innova Car Rental",
      "description": "Rent an Innova for your long-distance trip from Pune to Bangalore. Our Innova car rental service offers flexibility, allowing you to travel at your own pace, with all the space and comfort you need for a long journey."
    },
    {
      "name": "Pune to Bangalore One-Way Innova",
      "description": "Planning a one-way trip from Pune to Bangalore? Our one-way Innova service is the perfect solution. Travel in comfort without worrying about return trips or additional charges for longer routes."
    },
    {
      "name": "Pune to Bangalore Round Trip Innova",
      "description": "For those planning a round trip, our Pune to Bangalore round-trip Innova service offers you a convenient option. You can book your travel dates and customize your itinerary, making the journey easier and more enjoyable."
    },
    {
      "name": "Pune to Bangalore Luxury Innova Taxi",
      "description": "Enjoy a luxurious ride with our premium Innova taxi service for your Pune to Bangalore trip. With plush interiors and modern amenities, our luxury Innova taxis ensure a high-end travel experience throughout your journey."
    },
    {
      "name": "Affordable Bangalore Innova Cab",
      "description": "If you're looking for an affordable travel option, our Pune to Bangalore Innova taxi service offers competitive rates while ensuring comfort and reliability. No matter your budget, we provide excellent service without compromising on quality."
    },
    {
      "name": "Bangalore Trip from Pune by Innova",
      "description": "Take a relaxed and comfortable trip from Pune to Bangalore by booking an Innova cab. Whether for business, leisure, or sightseeing, our Innova cabs provide an ideal and comfortable mode of transport for your journey."
    },
    {
      "name": "Bangalore Tour in Innova from Pune",
      "description": "If you're planning to explore Bangalore, our Innova cab service is perfect for a sightseeing tour. Visit the city's top attractions, from the majestic Lalbagh Botanical Gardens to the historic Bangalore Palace, all while traveling in comfort."
    },
    {
      "name": "Group Travel to Bangalore in Innova",
      "description": "Traveling with family or friends? Our Innova cabs are spacious enough to accommodate large groups, making it an excellent choice for group travel to Bangalore. Everyone can sit back and relax while enjoying the journey."
    },
    {
      "name": "Book Innova for Bangalore Trip",
      "description": "Whether you're visiting Bangalore for a holiday, business, or a special occasion, booking an Innova cab ensures that your trip is comfortable, relaxing, and stress-free. Enjoy the luxury of a private vehicle throughout your trip."
    },
    {
      "name": "Bangalore Taxi Service from Pune",
      "description": "Looking for a reliable taxi service for your trip to Bangalore? Our Pune to Bangalore taxi service offers you an excellent way to travel with experienced drivers who know the best routes for a safe and smooth journey."
    },
    {
      "name": "Book Innova for Long-Distance Travel",
      "description": "If you're looking for long-distance travel, our Innova cabs provide the comfort, safety, and reliability you need. Book an Innova for your Pune to Bangalore journey and enjoy a smooth, uninterrupted ride over the long distance."
    },
    {
      "name": "Pune to Bangalore One-Way Taxi",
      "description": "For a one-way journey from Pune to Bangalore, book your Innova taxi with us. Our service is perfect for those who need a direct, comfortable, and hassle-free ride without the need to worry about the return leg of the trip."
    },
    {
      "name": "Bangalore Sightseeing with Innova",
      "description": "Explore Bangalore at your own pace by booking an Innova taxi for sightseeing. Visit popular spots such as the Bangalore Palace, Nandi Hills, and Cubbon Park while enjoying a comfortable ride with our professional drivers."
    }
  ],

"tableData": [
  ["Pune to Bangalore Innova Taxi", "Book Pune to Bangalore Innova Cab"],
  ["Pune to Bangalore Innova Car Rental", "Pune to Bangalore One-Way Innova"],
  ["Pune to Bangalore Round Trip Innova", "Pune to Bangalore Luxury Innova Taxi"],
  ["Affordable Bangalore Innova Cab", "Bangalore Trip from Pune by Innova"],
  ["Bangalore Tour in Innova from Pune", "Group Travel to Bangalore in Innova"],
  ["Book Innova for Bangalore Trip", "Bangalore Taxi Service from Pune"],
  ["Book Innova for Long-Distance Travel", "Pune to Bangalore One-Way Taxi"],
  ["Bangalore Sightseeing with Innova", ""]
],
"whychoose": [
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "At S9 Travels, we understand the importance of time, especially for long trips like Pune to Bangalore. Our drivers ensure punctual pickups from your location in Pune and a timely drop-off in Bangalore, providing a hassle-free and efficient travel experience."
  },
  {
    "WhyChooseheading": "Comfortable and Spacious Vehicles",
    "WhyChoosedescription": "The Toyota Innova is the perfect vehicle for long-distance journeys like Pune to Bangalore. With comfortable seating, ample legroom, air conditioning, and a smooth ride, you'll enjoy a relaxed journey whether you’re traveling alone, with family, or in a group."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our experienced and professional drivers are familiar with the best routes from Pune to Bangalore, ensuring a safe and smooth journey. They are trained to provide excellent customer service and to drive safely and efficiently on long trips."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Pricing",
    "WhyChoosedescription": "S9 Travels offers competitive pricing for your Pune to Bangalore Innova ride. With no hidden charges and a clear breakdown of costs, you can be assured of affordable and transparent pricing, helping you plan your trip without worrying about surprise costs."
  },
  {
    "WhyChooseheading": "Safe and Comfortable Journey",
    "WhyChoosedescription": "Your safety is our top priority. Our Innova cabs come with modern safety features such as airbags, seat belts, and GPS tracking. You can travel with peace of mind, knowing that we are committed to your safety and comfort throughout the journey."
  },
  {
    "WhyChooseheading": "24/7 Availability",
    "WhyChoosedescription": "Whether you're planning an early morning trip or a late-night departure, S9 Travels is available 24/7 to accommodate your travel needs. Our customer service team is always ready to assist with bookings and any changes to your schedule."
  },
  {
    "WhyChooseheading": "Hassle-Free Booking Process",
    "WhyChoosedescription": "Booking your Pune to Bangalore Innova cab is simple and convenient. You can book online through our website or mobile app, or contact our customer service team for any personalized assistance. We make the process seamless and easy."
  },
  {
    "WhyChooseheading": "Customized Travel Packages",
    "WhyChoosedescription": "We offer customized travel packages tailored to your preferences. Whether you want to make extra stops, need a sightseeing tour along the way, or have any specific travel needs, we can tailor the journey to make your trip special."
  }
]

























    }



    const faqData = [
        [
          {
            question: 'How can I book an Innova for Pune to Bangalore?',
            answer: 'You can book your Innova cab easily via our website, mobile app, or by contacting our customer service team for any assistance. We offer a seamless and easy booking process.',
          },
          {
            question: 'What is the seating capacity of the Innova?',
            answer: 'The Toyota Innova comfortably accommodates up to 6 passengers, making it ideal for families, groups, or business travel.',
          },
          {
            question: 'Are the drivers experienced for long-distance travel from Pune to Bangalore?',
            answer: 'Yes, our drivers are highly experienced in long-distance travel and are well-acquainted with the best routes to Bangalore. They ensure a smooth, safe, and comfortable journey for you.',
          },
          {
            question: 'What payment options are available for booking the Innova?',
            answer: 'We offer flexible payment options including cash, credit/debit cards, and online payment through our app, making it convenient for you to pay for your trip.',
          },
          {
            question: 'Can I book a round trip from Pune to Bangalore?',
            answer: 'Yes, we can arrange a round trip. Just provide us with your return details, and we’ll ensure your travel is smooth and hassle-free both ways.',
          },
          {
            question: 'Are there any extra charges for waiting or detours?',
            answer: 'Any additional charges, like waiting time or detours, will be clearly communicated to you upfront, ensuring full transparency in pricing.',
          },
          {
            question: 'Can I make extra stops during my journey to Bangalore?',
            answer: 'Yes, if you’d like to make extra stops for sightseeing or any other purpose, please let us know during the booking process, and we’ll customize your journey accordingly.',
          },
          {
            question: 'What is the luggage allowance for the Innova cab?',
            answer: 'The Toyota Innova has ample space for standard luggage. If you have additional luggage or special requirements, please inform us during the booking process, and we’ll accommodate your needs.',
          },
          {
            question: 'Is S9 Travels available for corporate travel to Bangalore?',
            answer: 'Yes, we offer corporate travel services to Bangalore. Whether it’s for business meetings, conferences, or group travel, we ensure a professional, reliable, and comfortable experience.',
          },
          {
            question: 'Why should I choose S9 Travels for my Pune to Bangalore Innova ride?',
            answer: 'S9 Travels provides a reliable, safe, and comfortable travel experience with experienced drivers, well-maintained vehicles, and affordable pricing. We guarantee a smooth and enjoyable journey from Pune to Bangalore.',
          },
        ]
      ];
      
      const testimonialsData = [
        {
          name: 'Mr. Rahul Patil',
          designation: 'Customer',
          rating: [1, 1, 1, 1, 1],
          text: '“Our trip from Pune to Bangalore was fantastic. The Innova was spacious, comfortable, and well-maintained. The driver was professional and made the entire journey smooth and enjoyable. We will definitely book with S9 Travels again for our next trip!”',
        },
        {
          name: 'Mrs. Priya Sharma',
          designation: 'Customer',
          rating: [1, 1, 1, 1, 1],
          text: '“I traveled from Pune to Bangalore for a business trip, and S9 Travels made the journey very comfortable. The driver was punctual and courteous, and the Innova was perfect for a long-distance trip. Highly recommend their service!”',
        },
      ];
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
    
    
    
    
    








    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 8850328441",
            "+91 9552526916",

        ],
        email: "booking@s9travels.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Book Pune To Nashik Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Book Pune To Ganpatipule Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Book Pune To Ratnagiri Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Book Pune To Devkund Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Book Pune To Goa Cab Taxi",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Book Pune To Kolhapur Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Book Pune To Lonavala Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Book Pune To Alibaug Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Book Pune To Aurangabad Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Book Pune To Bhimashankar Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Book Murud Janjira Cab From Pune",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Book Pune To Adlabs Imagica Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Book Pune To Mahabaleshwar Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Book Pune To Trimbakeshwar Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Pune Mumbai Pune Round Trip",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Mumbai Pune Pickup Drop",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Outstation Cabs From Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service In Pune",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "12 Jyotirlinga Yatra From Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune To Grishneshwar Cab Services",
        },
        
        {
            place: "/images/keyword/22.jpg",
            text: "Pune To Malshej Ghat Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune To Pandharpur Cab Service",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Pune To Panhala Fort Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune To Raigad Fort Cab Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Pune To Satara Kas Pathar Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Pune To Shirdi Cab Pickup Drop",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


   
      
    const productSchema = {
        "@context": "https://schema.org",
        "@type": "Product",
        "name": "Pune to Bangalore Innova Cab",
        "description": "Book an Innova taxi for your trip from Pune to Bangalore. Offering one-way, round-trip, and group travel options with luxury and affordable cab services for sightseeing and long-distance travel.",
        "aggregateRating": {
          "@type": "AggregateRating",
          "bestRating": "5",
          "worstRating": "1",
          "ratingValue": "4.7",
          "ratingCount": "720"
        }
      };
    
      
      


    return (
        <div>
           
      <Helmet>
        <title>Pune to Bangalore Innova Cab | Affordable and Luxury Taxi Services</title>
        <meta 
          name="description" 
          content="Book Pune to Bangalore Innova taxi for a comfortable journey. Choose from one-way, round-trip, or group travel for your Bangalore sightseeing and private tours." 
        />
        
        {/* Inject JSON-LD Schema */}
        <script type="application/ld+json">
          {JSON.stringify(productSchema)}
        </script>
      </Helmet>
      
<section className="page-title centred">
      <div className="bg-layer" style={{ backgroundImage: 'url(/images/background/page-title.jpg)' }}></div>
      <div className="auto-container">
        <div className="content-box">
        
          <h1>{cardData.keyword}</h1>
        </div>
      </div>
    </section>

      

            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/34.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                  <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For S9 Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                            <FAQKeyword  faqs={faqData} />

                                                {/* <FAQKeyword faqData={faqData} /> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />
                         

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #252E5B',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#252E5B' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+918850328441" className="d-block  text-white">+91 8850328441</a>
                                                <a href="tel:+919552526916" className="d-block  text-white">+91 9552526916</a>
                                                


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@s9travels.com" className=" text-white d-block">
                                                    booking@s9travels.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> S9 Travels <br/>
                                                    Khandesh Nagar, Ghandharva Nagri, Moshi,Pune, pin-412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Punetobangloreinnovacab;